import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllPreliminaryAnalysisResultDTO = BaseReportsPaginated;

export type ListAllPreliminaryAnalysisResultResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listPreliminaryAnalysisResultPaginated(
	params: ListAllPreliminaryAnalysisResultDTO
): Promise<ListAllPreliminaryAnalysisResultResponse> {
	const url = '/ergonomic-tool/preliminary-analysis/reports/list-all';
	const { data } = await Api.get<ListAllPreliminaryAnalysisResultResponse>(url, {
		params
	});
	return data;
}

export const useListPreliminaryAnalysisResultPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllPreliminaryAnalysisResultDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const aepResultList = useQuery<ListAllPreliminaryAnalysisResultResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_PRELIMINARY_ANALYZES_RESULT_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listPreliminaryAnalysisResultPaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				activity_id,
				report_name,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return aepResultList;
};
